import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchLinkedEntities,
  clearLinkedEntities,
} from '../../routines/linkedEntityRoutine';
import envConfig from '../../../config';
import { request } from '../../../common/util/RestClient';

export function* getLinkedEntities({ payload }) {
  const { level, entityId } = payload;
  try {
    if (!level || !entityId) {
      yield put(clearLinkedEntities.trigger());
    } else {
      const URL = `${envConfig.APIG_URL}entity-flat/${level}s/${entityId}/relationships`;
      const response = yield call(request, URL);
      yield put(
        fetchLinkedEntities.success({ level, data: response.data, entityId })
      );
    }
  } catch (error) {
    yield put(fetchLinkedEntities.failure({ error }));
  }
}

export default function* root() {
  yield all([takeLatest(fetchLinkedEntities.TRIGGER, getLinkedEntities)]);
}
